<template>
    <div>
        <form @submit.prevent="claimListing" enctype="multipart/form-data" class="contact-form">
            <div class="input-field">
                <label for="claimant_name">Your Name</label>
                <input type="text" name="name" id="claimant_name" class="form-control" v-model="claim.username">
            </div>
            <div class="input-field">
                <label for="claimant_email">Your Email</label>
                <input type="email" name="email" id="claimant_email" class="form-control" v-model="claim.useremail">
            </div>
            <div class="input-field" style="max-height: 43px">
                <v-app>
                    <v-autocomplete
                            v-model="model"
                            :items="items"
                            :loading="isLoading"
                            :search-input.sync="search"
                            chips
                            clearable
                            dense
                            hide-no-data
                            cache-items
                            attach
                            item-text="spa_name"
                            item-value="spa_name"
                            label="Type in spa name..."
                            multiple
                    >
                        <template
                                slot="selection"
                                slot-scope="{ item, selected }"
                        >
                            <v-chip
                                    :input-value="selected"
                                    color="blue-grey"
                                    class="white--text"
                            >
                                <v-icon left>mdi-checkbox-marked</v-icon>
                                <span v-text="item.spa_name"></span>
                            </v-chip>
                        </template>

                    </v-autocomplete>
                </v-app>
            </div>
            <div class="input-field">
                <label for="message">Message</label>
                <textarea type="text" name="message" id="message" class="materialize-textarea form-control" rows="10" v-model="claim.message"></textarea>
            </div>
            <div class="input-field">
                <button type="submit" class="btn btn-primary waves-effect waves-light">Send</button>
            </div>
        </form>
    </div>

</template>
<script>
export default {

    props: ['username', 'useremail'],
    data(){
        return {
            isLoading: false,
            items: [],
            model: null,
            search: null,
            claim: {
                username: this.username ? this.username : '',
                useremail: this.useremail ? this.useremail : '',
                message: '',
            }
        }
    },
    computed: {
        fields () {
            if (!this.model) return []
            return Object.keys(this.model).map(key => {
                    return {
                        key: key,
                        value: this.model[key] || 'n/a'
                    }
                })
        }
    },
    watch: {
        search (val) {
            // Items have already been loaded
            // Items have already been requested
            if (this.isLoading) return;
            this.isLoading = true;
            // Lazily load input items
            axios.get('/listingSearch',{params: {query: this.search}})
                .then(res => {
                this.items = res.data
                })
                .catch(err => {
                        console.log(err)
                })
                .finally(() => (this.isLoading = false))

        }
    },
    methods: {
        claimListing() {
            axios.post('/submitclaim',{
                name: this.claim.username,
                email   : this.claim.useremail,
                spas: this.model,
                message: this.claim.message
            }).then(response => {
                console.log(this.claim.message);
                console.log(response);
                swal(
                    'Success!',
                    'We will get back to you shortly',
                    'success'
                );
            })
            .catch(error => {
                    console.log(error);

            });
        }
    }
}

</script>


// WEBPACK FOOTER //
// resources/assets/js/components/ClaimListing.vue